import { REPORT_JOB_TYPES } from '@vy/types';
import saveAs from 'file-saver';
import { useMemo } from 'react';
import { useGetUnapprovedInvoicesReport } from '../../../../../hooks/requests/use-get-unapproved-invoices-report';
import { runMutation } from '../../../../../utils/vy-mutation';
import { useReportTypeStateParam } from '../../reports-page-hooks/report-type-state-param-hook';
import { REPORT_TYPES } from '../../reports-page-types/report-type';
import type { ReportJobsDownloadProps } from '../report-jobs-section/ReportJobsSection';
import { getReportJobType } from '../ReportsPageContent';

const UNAPPROVED_INVOICES_FILENAME = 'Unapproved Invoices';

export const useUnapprovedInvoicesDownloadProps = () => {
  const getUnapprovedInvoicesDownloadMutation = useGetUnapprovedInvoicesReport();
  const [reportType] = useReportTypeStateParam();

  const selectedReportJob = getReportJobType(reportType ?? REPORT_TYPES.ALL_REPORTS);

  const downloadProps = useMemo(() => {
    if (selectedReportJob !== REPORT_JOB_TYPES.UnapprovedInvoices) {
      return {};
    }

    return {
      asDownload: true,
      onDownload: async (reportJobId: string) => {
        await runMutation(
          getUnapprovedInvoicesDownloadMutation,
          { reportId: reportJobId },
          {
            pending: 'Downloading...',
            success: 'Download complete',
            error: 'Failed to download',
          },
          {
            onSuccess: async (unapprovedInvoicesReport) => {
              saveAs(unapprovedInvoicesReport, UNAPPROVED_INVOICES_FILENAME);
            },
          },
        );
      },
    } satisfies ReportJobsDownloadProps;
  }, [selectedReportJob, getUnapprovedInvoicesDownloadMutation]);

  return downloadProps;
};
